var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('SiteHeader'),_c('transition',{attrs:{"name":"slither","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1),_c('SiteFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }